import { Polyglot } from 'components/translate';
import deburr from 'lodash/deburr';
import { action } from 'mobx';
import Store from 'modules/userManager/userSearch/deepSearch/DeepSearchStore';

class PagesContentService {
  concludedOptions = () => {
    return [
      {
        value: 'CONCLUDED',
        label: Polyglot.t('general.concluded')
      },
      {
        value: 'NON_CONCLUDED',
        label: Polyglot.t('general.non_concluded')
      }
    ];
  };

  @action
  checkModulesAndPages = (items, ids, incompleteIds = []) =>
    items.map((item) => {
      item.pages = item.pages.map((page) => {
        const isCompleted = ids.includes(page.value);
        const isIncompleted = incompleteIds.includes(page.value);
        const checked = isCompleted || isIncompleted;

        return {
          ...page,
          checked,
          concluded: this.getConcludedValue(
            isCompleted,
            this.concludedOptions()
          ),
          show: true
        };
      });
      item.checked = item.checked = item.pages.every((page) => page.checked);
      item.show = true;

      return item;
    });

  @action
  fillSelectedItemsFiltered = (
    selectedItemsFiltered,
    items,
    incompleteIds = []
  ) => {
    items.forEach((item) => {
      item.pages.forEach((page) => {
        if (page.checked || incompleteIds.includes(page.id)) {
          selectedItemsFiltered.push(page);
        }
      });
    });

    return selectedItemsFiltered;
  };

  @action
  getConcludedValue = (completed, concludedOptions) => {
    const concludedIndex = 0;
    const nonConcludedIndex = 1;

    return completed
      ? concludedOptions[concludedIndex]
      : concludedOptions[nonConcludedIndex];
  };

  @action
  getItemsFormatted = (items, fieldData, concludedOptions) => {
    const { incompletePage } = Store.deepSearch.contentFilter;
    const { ids, completed } = fieldData;
    const { ids: incompleteIds, completed: incompleted } = incompletePage;

    let itemsFormatted = [];
    let selectedItemsFiltered = [];
    let concludedValue = '';

    if (ids.length || incompleteIds.length) {
      itemsFormatted = this.checkModulesAndPages(items, ids, incompleteIds);
      selectedItemsFiltered = this.fillSelectedItemsFiltered(
        selectedItemsFiltered,
        items,
        incompleteIds,
        completed,
        incompleted
      );

      concludedValue = this.getConcludedValue(completed, concludedOptions);
    }

    return {
      itemsFormatted,
      selectedItemsFiltered,
      concludedValue
    };
  };

  @action
  getItemsUpdatedNonChecked = (items, itemToRemove) =>
    items.map((item) => {
      item.pages = item.pages.map((page) => {
        if (page.value === itemToRemove.value) {
          page.checked = false;
        }

        return page;
      });

      const hasAllItemsNonChecked = item.pages.every((item) => !item.checked);

      if (hasAllItemsNonChecked) {
        item.checked = false;
      }

      return item;
    });

  @action
  getSelectedItemsValueRemoved = (selectedItemsFiltered, itemToRemove) => {
    const index = selectedItemsFiltered.findIndex(
      (item) => item.value === itemToRemove.value
    );

    selectedItemsFiltered.splice(index, 1);

    return selectedItemsFiltered;
  };

  @action
  filterItemsByValue = (selectedItemsFiltered) =>
    selectedItemsFiltered.map((itemFiltered) => itemFiltered.value);

  @action
  checkModules = (item) => {
    item.checked = !item.checked;

    item.pages = item.pages.map((page) => ({
      ...page,
      checked: item.checked
    }));

    return item;
  };

  @action
  checkPages = (item, value) => {
    item.pages = item.pages.map((page) => {
      if (page.id === value) {
        page.checked = !page.checked;
      }

      return page;
    });

    item.checked = item.pages.every((page) => page.checked);

    return item;
  };

  @action
  checkItemsFiltered = (items, value) =>
    items.map((item) =>
      item.id === value ? this.checkModules(item) : this.checkPages(item, value)
    );

  @action
  showModules = (item) => {
    item.show = true;

    item.pages = item.pages.map((page) => ({
      ...page,
      show: true
    }));

    return item;
  };

  @action
  showPages = (item, regexSearchedValue) => {
    item.pages = item.pages.map((page) => ({
      ...page,
      show: Boolean(deburr(page.name).match(regexSearchedValue))
    }));

    const hasPagesSelected = item.pages.find((page) => page.show);

    item.show = Boolean(hasPagesSelected);

    return item;
  };

  @action
  showItemsFiltered = (items, regexSearchedValue) =>
    items.map((item) =>
      regexSearchedValue.test(deburr(item.name))
        ? this.showModules(item)
        : this.showPages(item, regexSearchedValue)
    );

  hasPagesChanged = (nextProps = {}, prevState) => {
    const { completed = {}, incompleted = {} } = nextProps.fieldData || {};
    const { completedDataIds = [], incompletedDataIds = [] } = prevState;
    const completedChange =
      completed.ids && completed.ids.length !== completedDataIds.length;
    const incompletedChange =
      incompleted.ids && incompleted.ids.length !== incompletedDataIds.length;

    return completedChange || incompletedChange;
  };
}

export default new PagesContentService();
